import styled from "styled-components";
/* import BindeleddetStandardLogo from "../BindeleddetLogoComponents/BindeleddetStandardLogo/BindeleddetStandardLogo"; */
import { useLocation } from "react-router-dom";
import { useViewport } from "@bindeleddet/core/hooks";
import RightNav from "./RightNav";

export const NAVBAR_HEIGHT = 65;

const Nav = styled.nav<{ pathname: string }>`
  width: calc(100% - 270px);
  height: ${NAVBAR_HEIGHT}px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  background-color: var(--neutral);
  top: 0;
  right: 0;
  position: fixed;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  z-index: 140;
`;

const AdminNavbar = () => {
  const { pathname } = useLocation();
  const { width } = useViewport();
  return (
    <Nav pathname={pathname} style={{ justifyContent: "flex-end", width: width > 768 ? "calc(100% - 270px)" : "100%" }}>
      <RightNav />
    </Nav>
  );
};

export default AdminNavbar;
